import React from 'react'
import { shouldShowInsuranceDescriptionAsCenterDescription } from '../../../domain/center/useCases/shouldShowInsuranceDescriptionAsCenterDescription'
import { localizeCenterToCentre } from '../../../utils/localizeCenter'
import getCenterDescription from '../../../domain/center/useCases/getCenterDescription'
import { isSamhsa } from '@/domain/center'

export const CenterCardDescription = ({
  center,
  activeFacets,
  currentRefinements,
  shouldDefaultRegionalize = false
}) => {
  const showInsuranceDescription =
    shouldShowInsuranceDescriptionAsCenterDescription(currentRefinements)

  let centerDescription = getCenterDescription({
    center,
    termsList: activeFacets,
    showInsuranceDescription
  })

  if (shouldDefaultRegionalize) {
    centerDescription = localizeCenterToCentre(centerDescription)
  }

  if (centerDescription.endsWith('.')) {
    centerDescription = centerDescription.slice(0, -1)
  }

  const isSamhsaCenter = isSamhsa(center)
  if (isSamhsaCenter) {
    centerDescription = null
  }

  return (
    <div className="text-sm font-normal tracking-normal text-gray-800">
      {centerDescription && (
        <>
          {centerDescription}{' '}
          <span className="inline font-semibold text-gray-900 underline md:no-underline md:hover:underline">
            More
          </span>
        </>
      )}
    </div>
  )
}
